/* eslint-disable quotes */
/* eslint-disable semi */
import { storeGetters } from '../../getters.constants';

const getters = {
  [storeGetters.getOrgName]: (state) => {
    return state.organization_name;
  },
  [storeGetters.getLicense]: (state) => {
    return state.licenses;
  },
  [storeGetters.getLicenseByid]: (state) => {
    return state.license;
  },
  [storeGetters.getLicenseCount]: (state) => {
    return state.licenseCount;
  },
  [storeGetters.getCustomers]: (state) => {
    return state.customers;
  },
  [storeGetters.getCustomerProfile]: (state) => {
    return state.customer;
  },

};
export default { ...getters };
